import type { QueryDisplay, QuerySpec } from './types';

/** A contiguous partition keeps grouping order, query aliases and saved reports intact. */
export function pivotRowCount(dimensions: number, display?: QueryDisplay | null): number {
    const requested = display?.pivotRowCount;
    return Math.max(1, Math.min(dimensions - 1, Number.isInteger(requested) ? requested! : dimensions - 1));
}

export function movePivotField(spec: QuerySpec, index: number, target: 'rows' | 'columns'): void {
    const fields = spec.dimensions ?? [];
    const count = pivotRowCount(fields.length, spec.display);
    const fromRows = index < count;
    if (index < 0 || index >= fields.length || fromRows === (target === 'rows')) return;
    if (fromRows ? count === 1 : fields.length - count === 1) return;
    const [field] = fields.splice(index, 1);
    const nextCount = count + (target === 'rows' ? 1 : -1);
    fields.splice(target === 'rows' ? count : nextCount, 0, field);
    (spec.display ??= {}).pivotRowCount = nextCount;
}
